import type { Principal } from '../../api/types';
import { runsJobs } from '../../tenant/role';

/**
 * Where New job's address sends a person who may not make a job (a reviewer, a scanner operator:
 * the API makes jobs for admins and managers), or null to let them in. The jobs home shows the
 * button off for them; the address opened the dialog all the same and failed at the last step
 * (review 2026-10-06).
 */
export function newJobGate(
  principal: Principal | null,
  tenant: string,
): { to: '/t/$tenant'; params: { tenant: string } } | null {
  if (!principal || runsJobs(principal, tenant)) return null;
  return { to: '/t/$tenant', params: { tenant } };
}
